import gsap from 'gsap';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';

export default class CharacterScreen {
  constructor(camera, canvas) {}
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    this.proceeded = false;
    document.querySelector('#play').addEventListener('click', () => {
      Global.soundEnabled && document.querySelector('#tapAudio').play();
      this.play();
    });
    document.querySelector('#male').addEventListener('click', () => {
      Global.soundEnabled && document.querySelector('#tapAudio').play();
      Global.gender = 'male';
      document.querySelector('#male').classList.add('active2');
      document.querySelector('#female').classList.remove('active2');
    });
    document.querySelector('#female').addEventListener('click', () => {
      Global.soundEnabled && document.querySelector('#tapAudio').play();
      Global.gender = 'female';
      document.querySelector('#male').classList.remove('active2');
      document.querySelector('#female').classList.add('active2');
    });
  }

  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'CharacterSelection') return false;

    document.querySelector('#charecter_screen').classList.add('active');

    gsap.delayedCall(0.0, () => {
      document.querySelector('#charecter_screen').classList.add('active2');
    });
    gsap.delayedCall(0.2, this.animateScreen.bind(this));
  }
  animateScreen() {
    gsap.delayedCall(0.0, () => {
      document.querySelector('#charecter_screen .logo').classList.add('active');
    });
    gsap.delayedCall(0.2, () => {
      document
        .querySelector('#charecter_screen #choose')
        .classList.add('active');
    });
    gsap.delayedCall(0.3, () => {
      document
        .querySelector('#charecter_screen .box:nth-child(1)')
        .classList.add('active');
    });
    gsap.delayedCall(0.6, () => {
      document
        .querySelector('#charecter_screen .box:nth-child(2)')
        .classList.add('active');
    });
    gsap.delayedCall(0.9, () => {
      document.querySelector('#charecter_screen .btn').classList.add('active');
    });
  }
  hideScreen() {
    gsap.delayedCall(0.0, () => {
      document
        .querySelector('#charecter_screen .logo')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#charecter_screen #choose')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#charecter_screen .box:nth-child(1)')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#charecter_screen .box:nth-child(2)')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#charecter_screen .btn')
        .classList.remove('active');
    });
    gsap.delayedCall(1, () => {
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_game_view',
        },
      });
    });
    gsap.delayedCall(1.5, () => {
      document.querySelector('#charecter_screen').classList.remove('active');
      document.querySelector('#charecter_screen').classList.remove('active2');

      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_screen',
          data: {
            screenKey: 'Instructions',
          },
        },
      });
    });
  }
  play() {
    if (this.proceeded) return;

    this.proceeded = true;

    Global.serverObj.send(
      `${Global.BASE_URL}webservice.php`,
      (response) => {},
      null,
      {
        saveType: 'saveGender',
        gender: Global.gender,
      },
      'POST',
      null,
      false
    );
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'playClick',
      uniqID: Global.U_ID,
    });
    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'add_player',
        data: {},
      },
    });

    this.hideScreen();
  }
}
